import { __spreadArrays } from "tslib";
import { occurrences } from './occurrences';
import { sortByMatchesInAnswer } from './sort-by-matches-in-answer';
export var prioritizeFaqItems = function (faqItems, query) {
    var loweredQuery = query.toLowerCase();
    var foundInQuestionsAndAnswers = faqItems
        .filter(function (x) { return occurrences(x.question, loweredQuery) > 0; })
        .filter(function (x) { return occurrences(x.answer, loweredQuery) > 0; });
    var foundInQuestionsOnly = faqItems
        .filter(function (x) { return occurrences(x.question, loweredQuery) > 0; })
        .filter(function (x) { return occurrences(x.answer, loweredQuery) === 0; });
    var foundInAnswersOnly = faqItems
        .filter(function (x) { return occurrences(x.question, loweredQuery) === 0; })
        .filter(function (x) { return occurrences(x.answer, loweredQuery) > 0; });
    return __spreadArrays(sortByMatchesInAnswer(foundInQuestionsAndAnswers, loweredQuery), foundInQuestionsOnly, sortByMatchesInAnswer(foundInAnswersOnly, loweredQuery));
};
